export default __webpack_public_path__ + "static/media/patients_smile.109ef003.png";